import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import instance from "../api/axios";
import { RequestcreateBooking } from "../api/route";
import EditFormModel from "../components/Models/editFormModel";
import RequestConfirmModel from "../components/Models/RequestConfirmModel";
import FailModel from "../components/Models/failModel";
import Button from "../components/Button";
import BackHeader from "../components/Home/BackHeader";
import StepIndicator from "../components/Home/StepIndicator";
import AppointmentDetailsCard from "../components/SessionDetail/AppointmentDetailsCard";
import PatientInfoCard from "../components/SessionDetail/PatientInfoCard";
import NotesCard from "../components/SessionDetail/NotesCard";
import AddressCard from "../components/SessionDetail/AddressCard";
import DiscountCard from "../components/SessionDetail/DiscountCard";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import { usePartner } from "../context/PartnerContext";
import { DEFAULT_SESSION_FEE, getSessionFee } from "../utils/pricing";

const RequestBookingStyled = () => {
  const libraries = ["places"];
  const center = { lat: 19.076, lng: 72.8777 };

  const [address, setAddress] = useState("");
  const [floor, setFloor] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openEditModel, setOpenEditModel] = useState(false);
  const [Fees, setFees] = useState(DEFAULT_SESSION_FEE);
  const [notes, setNotes] = useState("");
  const [showRequestConfirmModel, setShowRequestConfirmModel] = useState(false);
  const [showFailModel, setShowFailModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [user, setUser] = useState(null);
  const [marker, setMarker] = useState(center);
  const [autocomplete, setAutocomplete] = useState(null);

  const mapRef = useRef();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { partnerSlug } = useParams();
  const { config } = usePartner() || {};
  const { date, timing } = state;

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyBqKbHptbwiV5W2wsYy0J1G1x2AKk2aeRU",
    libraries,
  });

  const getDayWithSuffix = (day) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  };

  const parseToDate = (str) => {
    const parts = str.split(/[-/]/);
    if (parts.length === 3 && parts[0].length === 2) {
      const [dd, mm, yyyy] = parts;
      return new Date(`${yyyy}-${mm}-${dd}`);
    }
    return new Date(str);
  };

  const parsedDate = parseToDate(date);
  const month = parsedDate.toLocaleString("en-US", { month: "long" });
  const day = getDayWithSuffix(parsedDate.getDate());
  const year = parsedDate.getFullYear();
  const formattedDate = `${month} ${day}, ${year}`;
  const hour = timing;

  console.log("formattedDate", formattedDate);
  console.log("hour", hour);
  console.log("Raw timing value:", timing);

  const onLoad = useCallback((autocomplete) => setAutocomplete(autocomplete), []);

  const onPlaceChanged = useCallback(() => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        const location = place.geometry.location;
        setMarker({ lat: location.lat(), lng: location.lng() });
        setAddress(place.formatted_address);
      }
    }
  }, [autocomplete]);

  useEffect(() => {
    const userDetail = sessionStorage.getItem("user");
    const user = JSON.parse(userDetail);
    setUser(user);
    setFees(getSessionFee({ partnerSlug, config }));
  }, [config, partnerSlug]);

  useEffect(() => {
    setButtonDisabled(address.trim() === "" || floor.trim() === "");
  }, [address, floor]);

  const handleConfirmAppointment = async () => {
    setLoading(true);
    const userDetail = sessionStorage.getItem("user");
    const user = JSON.parse(userDetail);
    const obj = {
      user_name: user.name,
      user_phone: user.phone,
      user_pincode: user.pinCode,
      user_address: `${floor} ${address}`,
      user_city: user.address,
      time: hour,
      date: formattedDate,
      user_condition: user.pain_condition || "",
      notes: notes || "",
    };

    try {
      const response = await instance.post(RequestcreateBooking, obj);
      if (response?.data?.success) {
        setShowRequestConfirmModel(true);
      } else {
        setErrorMessage(response?.data?.message);
        setShowFailModel(true);
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message);
      setShowFailModel(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseConfirmModel = () => setShowRequestConfirmModel(false);
  const handleCloseFailModel = () => setShowFailModel(false);
  const handleBackButtonClick = () => navigate(-1);

  if (loadError) return "Error loading maps";
  if (!isLoaded || loading) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          zIndex: 1000,
          backdropFilter: "blur(2px)",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <style>
          {`
            .loader {
              width: 50px;
              --b: 8px;
              aspect-ratio: 1;
              border-radius: 50%;
              padding: 1px;
              background: conic-gradient(#0000 10%, #FE8235) content-box;
              -webkit-mask:
                repeating-conic-gradient(#0000 0deg, #000 1deg 20deg, #0000 21deg 36deg),
                radial-gradient(farthest-side, #0000 calc(100% - var(--b) - 1px), #000 calc(100% - var(--b)));
              -webkit-mask-composite: destination-in;
                      mask-composite: intersect;
              animation: l4 1s infinite steps(10);
            }
            @keyframes l4 {
              to { transform: rotate(1turn); }
            }
          `}
        </style>
        <div className="loader" />
        <div style={{ fontSize: "16px", fontWeight: 600, color: "#111827" }}>
          Requesting your Appointment
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen md:px-0 flex justify-center px-0 py-0 md:py-6 md:px-4">
      <div
        className="w-full max-w-[700px] md:rounded-2xl md:shadow-lg md:bg-cover md:bg-no-repeat"
        style={{
          backgroundImage: `url(${require("../assets/images/BackgroundBig.png")})`,
        }}
      >
        <div className="max-w-[700px] mx-auto">
          <BackHeader onBack={handleBackButtonClick} />
          <StepIndicator step={3} totalSteps={4} header="Request Appointment" />
          <DiscountCard />
          <AppointmentDetailsCard date={formattedDate} time={hour} price={`\u20B9${Fees}`} />
          <PatientInfoCard
            patientName={user?.name}
            patientPhone={user?.phone}
            pincode={user?.pinCode}
            condition={user?.pain_condition || "N/A"}
            showEdit={true}
            onEditClick={() => setOpenEditModel(true)}
          />
          <AddressCard
            address={address}
            setAddress={setAddress}
            floor={floor}
            setFloor={setFloor}
            buttonDisabled={buttonDisabled}
            onLoad={onLoad}
            onPlaceChanged={onPlaceChanged}
          />
          <NotesCard notes={notes} setNotes={setNotes} />
          <div className="mt-0 p-4 flex flex-col items-center">
            <div className="w-80">
              <Button
                btnName="Send Appointment Request"
                className={`w-full offer-gradient text-center text-white font-semibold text-lg px-1 py-2 my-1.5 rounded-xl ${buttonDisabled ? "cursor-not-allowed opacity-50" : ""}`}
                onClick={handleConfirmAppointment}
                disabled={buttonDisabled}
              />

              <Button
                btnName="Edit Details"
                className="w-full text-center border border-[var(--partner-primary)] text-[var(--partner-primary)] font-semibold text-lg px-1 py-2 my-1.5 rounded-xl bg-transparent"
                onClick={() => setOpenEditModel(true)}
              />
            </div>
          </div>
          {openEditModel && <EditFormModel setopenEditModel={setOpenEditModel} />}
          {showRequestConfirmModel && (
            <RequestConfirmModel
              onClose={handleCloseConfirmModel}
              date={formattedDate}
              time={hour}
            />
          )}
          {showFailModel && (
            <FailModel onClose={handleCloseFailModel} errorMessage={errorMessage} />
          )}
        </div>
      </div>
    </div>
  );
};

export default RequestBookingStyled;
